import React, { Component } from 'react'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import Columns from '../../../styles/columns'
import CardStyles from '../../../styles/cards'
import { connect } from 'react-redux'
import { fetchBenefitHistory } from '../../../redux/actions/benefitHistoryActions'
import { injectIntl } from 'react-intl'
import Loading from '../../../widgets/Loading'
import { localize } from '../../../util/Localizer'
import TitledLabel from '../../../controls/TitledLabel'
import NgrxDate from '../../../util/NgrxDateHelper'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '../../../controls/Tooltip'
import { Colors } from '../../../theme'
import Config from '../../../Config'

class BenefitHistory extends Component {
  constructor (props) {
    super(props)

    this.backToSummary = this.backToSummary.bind(this)
  }

  componentDidMount () {
    this.props.fetchBenefitHistory(this.props.selectedMember, this.props.type)
  }

  backToSummary () {
    this.props.goBack()
  }

  renderBenefitHistory (history, index) {
    const { classes = {} } = this.props
    return (
      <div key={index}>
        <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
          <Row>
            { !Config.member.benefits.hideCoverage &&
            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.category' value={history.benefitCoverage} format='text' />
            </Col>}

            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.status' value={history.status} format='text' />
            </Col>

            { !Config.member.benefits.hideEffectiveDate &&
            <Col {...Columns.max6}>
              <TitledLabel title='pages.coverageHistory.cardDetails.effDate' value={NgrxDate.SetDate(history.benefitEffectiveDate)} format='text' />
            </Col>}

            { !Config.member.benefits.hideExpiryDate &&
            <Col {...Columns.max6}>
              <TitledLabel title='pages.coverageHistory.cardDetails.expDate' value={NgrxDate.SetDate(history.benefitExpiryDate)} format='text' />
            </Col>}

            <Col {...Columns.max6}>
              <TitledLabel title='pages.cardDetails.Waived' value={localize((history.isWaived ? 'yesText' : 'noText'))} format='text' />
              <Tooltip title={localize('pages.benefitHistory.tooltip.waived')}>
                <IconButton
                  className='declinedTooltip'
                  role='button'>
                  <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                </IconButton>
              </Tooltip>
            </Col>
          </Row>
        </Card>
      </div>
    )
  }

  render () {
    if (!this.props.benefitHistories) {
      return (
        <div className=''>
          <Loading message={localize('common.loadingContent')} />
        </div>
      )
    } else {
      return (
        <div>
          <section>
            <div>
              <h4 className='sectionHeading'>{localize('pages.benefitHistory.Header') + ' - ' + this.props.currentMember.Name}</h4>
            </div>
            {this.props.benefitHistories.map((history, index) => {
              return this.renderBenefitHistory(history, index)
            })}
          </section>
        </div>
      )
    }
  }
}

function mapStateToProps (state, props) {
  return {
    benefitHistories: state.BenefitHistoryReducer.benefitHistory
  }
}

const ConnectedBenefitHistory = connect(mapStateToProps, { fetchBenefitHistory })(injectIntl(BenefitHistory))

const styles = {
  ...CardStyles
}

export default withStyles(styles)(ConnectedBenefitHistory)



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/BenefitHistory.js